import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { CheckoutResponse } from '../../core/checkout';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

export interface StoreSubscription {
  active: boolean;
  status: string;
}

export interface PortalURL {
  session_url: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  apiUrl = `${environment.API_URL}`;

  protected readonly HTTP_OPTIONS = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    protected readonly protectedHttpClient: HttpClient,
    protected readonly handler: HttpBackend,
    protected readonly googleAnalytics: GoogleAnalyticsService
  ) {
    this.apiUrl += 'subscriptions';
  }

  checkout(): Observable<CheckoutResponse> {
    this.googleAnalytics.gtag('event', 'begin_checkout', {
      currency: 'CAD',
      items: [
        {
          item_name: 'premium_subscription',
          price: 49.99,
          currency: 'CAD',
          quantity: 1,
        },
      ],
      value: 49.99,
    });
    const url = `${this.apiUrl}/checkout`;
    return this.protectedHttpClient.get<CheckoutResponse>(
      url,
      this.HTTP_OPTIONS
    );
  }

  getManagementPortalURL(): Observable<PortalURL> {
    const url = `${this.apiUrl}/portal`;
    return this.protectedHttpClient.get<PortalURL>(url, this.HTTP_OPTIONS);
  }

  getUserSubscription(): Observable<StoreSubscription> {
    return this.protectedHttpClient
      .get<StoreSubscription>(`${this.apiUrl}/status`, this.HTTP_OPTIONS)
      .pipe(catchError(() => EMPTY));
  }
}
